<template>
  <div>
    <!-- <b-col
      cols="12"
      class="text-right mb-1"
    >
      <b-button
        v-if="typeof(ReadOnly) === 'undefined'"
        class="col-2 ml-1"
        variant="danger"
        @click="onDeletedBtnClicked"
      >ลบ</b-button>
    </b-col> -->

    <b-col cols="12">
      <b-form-textarea
        v-model="complain.complainDetail"
        rows="3"
      />
    </b-col>

    <b-col cols="12">
      <ComplainChecklist :complain="complainData" />
    </b-col>

    <b-card title="ท่านมีความประสงค์เข้าไกล่เกลี่ยในรูปแบบออนไลน์หรือไม่">
      <b-col cols="12">
        <div class="demo-inline-spacing">
          <b-form-radio
            v-model="DMediateSelected"
            name="rdoDMediateSelected"
            value="1"
            class="custom-control-info"
          >
            ต้องการ
          </b-form-radio>
          <b-form-radio
            v-model="DMediateSelected"
            name="rdoDMediateSelected"
            value="0"
            class="custom-control-info"
          >
            ไม่ต้องการ
          </b-form-radio>
        </div>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormTextarea, BCard, BFormRadio, BTab, BTabs, BButton,
} from 'bootstrap-vue'
import ComplainChecklist from './ComplainChecklist.vue'

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    ComplainChecklist,
  },
  props: {
    dataI: {
      type: Object,
      required: true,
    },
    IsReadOnly: 0,
  },
  setup(props) {
    const tmp = []
    tmp.push(props.dataI)
    return {
      complainData: tmp,
      complain: props.dataI,
      DMediateSelected: '0',
      ReadOnly: props.IsReadOnly,
    }
  },
  methods: {
    onDeletedBtnClicked() {
      this.$emit('handle-deleted', this.complain.id)
    },
  },

}
</script>

<style>

</style>
